import Helpers from '../../../common/helpers/Helpers';
import Constants from '../../../common/constants/Constants';

export const getUpdates = () => {
  return Helpers.get(`${Constants.UPDATE_PACKAGES_URL}`);
};

export const getUserRegion = () => {
  return Helpers.get(`${Constants.USER_REGION}`);
};

export const getRegions = () => {
  return Helpers.get(Constants.REGIONS_URL);
};

export const deleteUpdate = (packageId) => {
  return Helpers.delete(`${Constants.UPDATE_PACKAGES_URL}/${packageId}`, {});
};

export const savePackage = (blobUrl) => {
  let query = {
    blobUrl: blobUrl,
  };

  return Helpers.get(`${Constants.UPDATE_PACKAGES_URL}/blob`, {}, query);
};

export const getBlobUrlForPackageUpload = (fileName) => {
  let query = {
    fileName: fileName,
  };

  return Helpers.get(`${Constants.FILE_TRANSFER_URL}/sasToken/packageUpload`, {}, query);
};
